export const FallBackFonts: string = 'system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif';
